module.exports = __webpack_public_path__ + "static/media/img_familia.838545f5.jpg";